"use client";

import { CommandGroup, CommandItem } from "@/components/ui/command";
import { useTranslations } from "next-intl";
import { MapPinIcon } from "lucide-react";
import type { SearchResultsListProps } from "./types";

export function SearchResultsList({
  suggestions,
  isSearching,
  isDebouncing,
  onSelect,
}: SearchResultsListProps) {
  const t = useTranslations();

  return (
    <CommandGroup>
      {suggestions.length > 0 ? (
        suggestions.map((prediction) => (
          <CommandItem
            key={prediction.placeId}
            value={prediction.placeId}
            onSelect={() => onSelect(prediction)}
            className="flex items-center gap-3 cursor-pointer px-2 py-3"
          >
            <div className="bg-muted/50 rounded-sm shrink-0 size-10 flex items-center justify-center overflow-clip">
              <MapPinIcon className="size-6 text-foreground" />
            </div>
            <div className="flex flex-col gap-0.5 min-w-0 flex-1">
              <span className="text-base leading-6 truncate">
                {prediction.mainText}
              </span>
              {prediction.secondaryText && (
                <span className="text-sm text-muted-foreground leading-5 truncate">
                  {prediction.secondaryText}
                </span>
              )}
            </div>
          </CommandItem>
        ))
      ) : isSearching || isDebouncing ? (
        <div className="py-4 text-center text-sm text-muted-foreground">
          {t("locationSelector.searching")}
        </div>
      ) : (
        <div className="py-4 text-center text-sm text-muted-foreground">
          {t("locationSelector.noResults")}
        </div>
      )}
    </CommandGroup>
  );
}
